// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe, arrayOf, recordOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

export const isAppSettingsV2InternalUserGroupsInternalUserGroupsResult = objectOf({
  id: string,
  name: string,
  property_data: recordOf({
    key: string,
    value: maybe(
      objectOf({
        is_enabled: boolean,
        is_default: maybe(boolean),
      })
    ),
  }),
  territory_ids: arrayOf(string),
});
